document.addEventListener("DOMContentLoaded", function() {
    // Initialize countdown timer
    initializeCountdown();

    function initializeCountdown() {
        // Set interval to 24 hours in milliseconds
        const interval = 24 * 60 * 60 * 1000;

        // Calculate the next interval's end time (i.e., when the timer resets)
        const now = new Date().getTime();
        const nextIntervalEnd = Math.ceil(now / interval) * interval;

        // Update the timer every second
        const countdownInterval = setInterval(function() {
            updateCountdown(nextIntervalEnd);
        }, 1000);
    }

    function updateCountdown(endTime) {
        const countdownElement = document.getElementById("countdown-timer");
        if (countdownElement) {
            const currentTime = new Date().getTime();
            const remainingTime = endTime - currentTime;

            // Calculate hours, minutes, and seconds
            const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

            // Display the countdown timer in the format hh:mm:ss
            countdownElement.innerHTML =
                (hours < 10 ? "0" : "") + hours + "h " +
                (minutes < 10 ? "0" : "") + minutes + "m " +
                (seconds < 10 ? "0" : "") + seconds + "s ";

            // If the countdown is over, reset the interval
            if (remainingTime <= 0) {
                clearInterval(countdownInterval);
                initializeCountdown(); // Restart the countdown
            }
        }
    }
});
